(function () {
  function getHeaderOffset() {
    var header = document.querySelector('.header-wrapper') || document.querySelector('header');
    return header ? header.getBoundingClientRect().height : 0;
  }

  function scrollHeaderIntoView(btn) {
    if (!btn) return;
    var rect = btn.getBoundingClientRect();
    var headerH = getHeaderOffset();
    var topSafe = headerH + 12;
    var bottomSafe = window.innerHeight - 24;
    var delta = 0;

    if (rect.top < topSafe) {
      delta = rect.top - topSafe;
    } else if (rect.bottom > bottomSafe) {
      delta = rect.bottom - bottomSafe;
    }

    if (delta === 0) return;
    window.scrollBy({ top: delta, left: 0, behavior: 'smooth' });
  }

  function initAccordions(scope) {
    var root = scope || document;
    var accordions = root.querySelectorAll('[data-sll-accordion]');
    if (!accordions.length) return;

    accordions.forEach(function (accordion) {
      if (accordion.dataset.sllInit === '1') return;
      accordion.dataset.sllInit = '1';

      var items = accordion.querySelectorAll('.sll-accitem');

      function closeAll(except) {
        items.forEach(function (item) {
          if (except && item === except) return;
          var btn = item.querySelector('[data-acc-btn]');
          var panel = item.querySelector('[data-acc-panel]');
          if (!btn || !panel) return;
          btn.setAttribute('aria-expanded', 'false');
          panel.hidden = true;
        });
      }

      // all collapsed on load
      closeAll();

      items.forEach(function (item) {
        var btn = item.querySelector('[data-acc-btn]');
        var panel = item.querySelector('[data-acc-panel]');
        if (!btn || !panel) return;

        btn.addEventListener('click', function () {
          var isOpen = btn.getAttribute('aria-expanded') === 'true';
          closeAll();
          if (!isOpen) {
            btn.setAttribute('aria-expanded', 'true');
            panel.hidden = false;
            if (accordion._sllScrollRaf) {
              cancelAnimationFrame(accordion._sllScrollRaf);
            }
            accordion._sllScrollRaf = requestAnimationFrame(function () {
              scrollHeaderIntoView(btn);
            });
          }
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAccordions(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAccordions(event.target);
  });
})();
